import React, { Fragment } from 'react';
import {Link, useParams } from 'react-router-dom'
import Teams from '../../api/team';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import ContactForm from '../ServiceSinglePage/ServiceFrom ';
import logo from '../../images/logo-2.svg'
import Arrow from '../../images/team-single/arrow.svg'


const progressData = [
    { label: 'Clinical Excellence Standards', value: 95 },
    { label: 'Patient Care Quality Metrics', value: 90 },
    { label: 'Treatment Protocol Compliance', value: 98 },
    { label: 'Safety Standards Achievement', value: 100 },
];



const TeamSinglePage = (props) => {

    const { slug } = useParams()
    const TeamSingles = Teams.find(item => item.slug === slug)

    return (
        <Fragment>
            <Navbar Logo={logo} hclass={'wpo-site-header wpo-site-header-s2'} />
            <PageTitle pageTitle="Medical Leadership" pagesub={'Florida Stem Cell Medical Clinic'} />
            <section className="team_single_page section-padding">
                <div className="container">
                    <div className="row align-items-end">
                        <div className="col-lg-6 col-12">
                            <div className="doctor_profile">
                                <img src={TeamSingles.Sime} alt="Dr. Eugene G. Pereira" />
                                <div className="content">
                                    <h3>Dr. Eugene G. Pereira, MD</h3>
                                    <span>Medical Director | Board-Certified Pain Management Specialist | Fellow of Interventional Pain Practice (FIPP)</span>
                                    <ul>
                                        <li><Link to="#"><i className="flaticon-facebook-app-symbol"></i></Link></li>
                                        <li><Link to="#"><i className="flaticon-twitter"></i></Link></li>
                                        <li><Link to="#"><i className="flaticon-linkedin"></i></Link></li>
                                        <li><Link to="#"><i className="flaticon-instagram"></i></Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6  col-12">
                            <div className="doctor_info">
                                <h2>Medical Director Profile</h2>
                                <table>
                                    <tbody>
                                        <tr>
                                            <th>Position:</th>
                                            <td>Medical Director, Florida Stem Cell Medical Clinic</td>
                                        </tr>
                                        <tr>
                                            <th>Department:</th>
                                            <td>Regenerative Medicine & Pain Management</td>
                                        </tr>
                                        <tr>
                                            <th>Experience:</th>
                                            <td>25+ Years Clinical Leadership</td>
                                        </tr>
                                        <tr>
                                            <th>FL License:</th>
                                            <td>Licensed in FL, NY, NJ, UT</td>
                                        </tr>
                                        <tr>
                                            <th>Contact:</th>
                                            <td>[CLINIC MAIN LINE]</td>
                                        </tr>
                                        <tr>
                                            <th>Location:</th>
                                            <td>[CLINIC LOCATION]</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="doctor_info s2">
                                <h2>Education & Training</h2>
                                <ul>
                                    <li><img src={Arrow} alt="" />MD - St. John's Medical College, Bangalore, India (1991)</li>
                                    <li><img src={Arrow} alt="" />Transitional Surgery Internship - Maimonides Medical Center, Brooklyn, NY (1994-1995)</li>
                                    <li><img src={Arrow} alt="" />Anesthesiology Residency - West Virginia University (1995-1998)</li>
                                    <li><img src={Arrow} alt="" />Anesthesiology Fellowship - West Virginia University (1999-2000)</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="experience_wrap">
                        <div className="top_content">
                            <h2>About Florida Stem Cell Medical Clinic</h2>
                            <p>Under the leadership of Medical Director Dr. Eugene G. Pereira, Florida Stem Cell Medical Clinic has established itself as a premier regenerative medicine facility in Southwest Florida. The clinic combines decades of pain management expertise with cutting-edge regenerative therapies to offer comprehensive treatment solutions.</p>
                            
                            <p>The clinic operates with a multidisciplinary approach, integrating traditional pain management techniques with advanced regenerative medicine protocols. This unique combination allows the medical team to address both immediate pain relief and long-term healing objectives for patients throughout Florida.</p>
                            
                            <p>Florida Stem Cell Medical Clinic maintains the highest standards of patient care through our state-of-the-art facility, hospital-grade safety protocols, and access to comprehensive medical resources.</p>
                        </div>
                        
                        <div className="skill_wrap">
                            <div className="skill">
                                <h2>Clinical Departments</h2>
                                <div className="department_list">
                                    <h4>Regenerative Medicine Department</h4>
                                    <ul>
                                        <li>Stem Cell Therapy Protocols</li>
                                        <li>Platelet-Rich Plasma (PRP) Treatments</li>
                                        <li>Bone Marrow Aspirate Concentrate (BMAC)</li>
                                        <li>Orthobiologic Procedures</li>
                                    </ul>
                                    
                                    <h4>Pain Management Department</h4>
                                    <ul>
                                        <li>Interventional Pain Procedures</li>
                                        <li>Diagnostic Imaging & Assessment</li>
                                        <li>Minimally Invasive Treatments</li>
                                        <li>Comprehensive Pain Evaluation</li>
                                    </ul>
                                    
                                    <h4>Patient Care Services</h4>
                                    <ul>
                                        <li>Clinical Nursing Staff</li>
                                        <li>Patient Coordination Team</li>
                                        <li>Physical Therapy Referral Network</li>
                                        <li>Post-Procedure Support</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="achievements">
                                <h2>Medical Director Credentials</h2>
                                <ul>
                                    <li><span>Board Certification: </span>American Board of Anesthesiology - Pain Management (2000)</li>
                                    <li><span>Fellowship: </span>Fellow of Interventional Pain Practice (FIPP)</li>
                                    <li><span>Diplomate: </span>American Board of Interventional Pain Physicians (ABIPP)</li>
                                    <li><span>Additional Certification: </span>Hospice and Palliative Medicine</li>
                                    <li><span>Multi-State Licensed: </span>Florida, New York, New Jersey, Utah</li>
                                    <li><span>Clinical Experience: </span>25+ Years in Pain Management Leadership</li>
                                </ul>
                            </div>
                        </div>
                        
                        <div className="additional_sections">
                            <div className="hospital_affiliations">
                                <h2>Clinical Standards & Resources</h2>
                                <ul>
                                    <li><img src={Arrow} alt="" />State-of-the-art regenerative medicine facility</li>
                                    <li><img src={Arrow} alt="" />Hospital-grade safety protocols and standards</li>
                                    <li><img src={Arrow} alt="" />Advanced laboratory and processing capabilities</li>
                                    <li><img src={Arrow} alt="" />Access to comprehensive medical resources</li>
                                </ul>
                            </div>
                            
                            <div className="leadership_education">
                                <h2>Clinical Excellence & Education</h2>
                                <ul>
                                    <li><img src={Arrow} alt="" />Physician training programs in advanced regenerative techniques</li>
                                    <li><img src={Arrow} alt="" />Collaboration with biomedical equipment manufacturers</li>
                                    <li><img src={Arrow} alt="" />Medical education seminars and professional development</li>
                                    <li><img src={Arrow} alt="" />Community health education on regenerative medicine options</li>
                                    <li><img src={Arrow} alt="" />International conference participation and knowledge exchange</li>
                                </ul>
                            </div>
                            
                            <div className="expertise_areas">
                                <h2>Clinical Services & Specialties</h2>
                                <div className="expertise_grid">
                                    <div className="expertise_item">
                                        <h4>Regenerative Medicine Services</h4>
                                        <ul>
                                            <li>Autologous Stem Cell Therapy</li>
                                            <li>Platelet-Rich Plasma (PRP) Protocols</li>
                                            <li>Bone Marrow Aspirate Concentrate (BMAC)</li>
                                            <li>Advanced Orthobiologic Treatments</li>
                                        </ul>
                                    </div>
                                    <div className="expertise_item">
                                        <h4>Pain Management Services</h4>
                                        <ul>
                                            <li>Comprehensive Pain Assessment</li>
                                            <li>Image-Guided Interventions</li>
                                            <li>Spinal Procedures</li>
                                            <li>Joint Injection Therapies</li>
                                            <li>Minimally Invasive Techniques</li>
                                        </ul>
                                    </div>
                                    <div className="expertise_item">
                                        <h4>Support Services</h4>
                                        <ul>
                                            <li>Diagnostic Imaging</li>
                                            <li>Laboratory Services</li>
                                            <li>Physical Therapy Coordination</li>
                                            <li>Patient Education Programs</li>
                                            <li>Insurance Verification Assistance</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="patient_approach">
                                <h2>Clinical Treatment Approach</h2>
                                <div className="approach_steps">
                                    <div className="step">
                                        <h4>1. Comprehensive Evaluation</h4>
                                        <p>The clinic's medical team conducts thorough assessments utilizing advanced diagnostic tools and detailed patient history reviews. This comprehensive approach ensures accurate diagnosis and appropriate treatment planning tailored to each patient's unique condition.</p>
                                    </div>
                                    <div className="step">
                                        <h4>2. Personalized Treatment Protocols</h4>
                                        <p>Based on evaluation findings, the clinical team develops individualized treatment plans incorporating appropriate regenerative therapies. Options may include PRP, BMAC, stem cell therapy, or integrated pain management approaches, all following evidence-based protocols.</p>
                                    </div>
                                    <div className="step">
                                        <h4>3. Ongoing Clinical Support</h4>
                                        <p>Florida Stem Cell Medical Clinic provides continuous patient monitoring and support throughout the treatment journey. The multidisciplinary team ensures optimal outcomes through regular follow-ups, progress assessments, and treatment adjustments as needed.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="closing_message">
                                <h2>Florida Stem Cell Medical Clinic</h2>
                                <p>Under the medical direction of Dr. Eugene G. Pereira, Florida Stem Cell Medical Clinic represents the convergence of traditional pain management excellence and cutting-edge regenerative medicine. The clinic's comprehensive approach, supported by a dedicated team of healthcare professionals, offers patients throughout Florida access to advanced treatment options previously unavailable in the region.</p>
                                <p>The clinic continues to expand its services and capabilities, maintaining its commitment to evidence-based medicine, patient safety, and clinical excellence in regenerative therapies.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="AppointmentFrom">
                    <div className="container">
                        <div className="cta_form_s2">
                            <div className="title s2">
                                <h3>Schedule a Consultation</h3>
                                <p>Contact Florida Stem Cell Medical Clinic to learn more about our regenerative medicine services and schedule your comprehensive evaluation with our medical team.</p>
                            </div>
                            <ContactForm />
                        </div>
                    </div>
                </div>
            </section>
            <Footer hclass={'wpo-site-footer_s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default TeamSinglePage;
